import {SET_ADDITIONAL_SELECTION_DATA} from '.';
import {
  SetSelectedAdditionalCheckBoxPayloadParams,
  SetSelectedAdditionalCheckBoxAction
} from '../mappers/SelectedAdditionalCheckBoxTypes';

export const setSelectedAdditionalCheckBox = (
  dispatch: (action: SetSelectedAdditionalCheckBoxAction) => void,
  params: SetSelectedAdditionalCheckBoxPayloadParams
): void => {
  dispatch({
    type: SET_ADDITIONAL_SELECTION_DATA,
    payload: params
  });
};
